import { __assign, __rest } from "tslib";
import React from "react";
import Table from "../calendar/tables/BaseTable";
import { Combobox } from "./TimeCombobox";
export function TimeTable(_a) {
    var caption = _a.caption, props = __rest(_a, ["caption"]);
    return (React.createElement(Table, { caption: caption },
        React.createElement(Combobox, __assign({}, props))));
}
TimeTable.displayName = "TimeTable";
//# sourceMappingURL=TimeTable.js.map